// extracted by mini-css-extract-plugin
module.exports = {"tag-icon":"tag-icon__GES8p","tag-icon__video":"tag-icon__video__5tZb3"};